export default __webpack_public_path__ + "static/media/ic_weather_8.71b3b71f.svg";